import { combineReducers } from 'redux';
import project, { committedProjectSlice } from './project/projectslice';
import results from './project/resultsSlice';
/* import template from './template/templateSlice'; */

export default combineReducers({
  /*   template, */
    committedProject: committedProjectSlice.reducer,
    project,
    results
});
